<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <HelloWorld />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import HelloWorld from '@/components/HelloWorld.vue';
export default {
  components: {HelloWorld},
  props: {},
  data() {
    return {
      appName: "GGrupos",
    };
  },
  mounted() {},
  activated() {},
  methods: {},
  computed: {},
};
</script>